import { render, staticRenderFns } from "./independent-skills.vue?vue&type=template&id=1b6b48e8&scoped=true"
import script from "./independent-skills.vue?vue&type=script&lang=js"
export * from "./independent-skills.vue?vue&type=script&lang=js"
import style0 from "./independent-skills.vue?vue&type=style&index=0&id=1b6b48e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b48e8",
  null
  
)

export default component.exports